import React from 'react'
import { css } from '@emotion/react'
import { Divider, Link, Typography } from '../base-ui'


function SidebarList({ title, items, href = '/', linkItem = true, style }) {
    const listStyle = css`
        display: flex;
        flex-direction: column;
        padding: 1rem;
        .bar-body {
            height: 300px;
            overflow-y: auto;

        }
        ${style};
    `
    return (
        <div css={listStyle}>
            <Typography type="h4">{title}</Typography>
            <Divider size="2px" />
            <div className="bar-body">
                {linkItem ? (items.map((item, idx) =>
                    <React.Fragment key={idx}>
                        <Link href={href}>
                            {item.content}
                        </Link>
                        <Divider />
                    </React.Fragment>

                )) : items}
            </div>
        </div>
    )
}

export default SidebarList